// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"vendors-hls_js_dist_hls_mjs":"8e4ec37aa9e6f84d6347","vendors-howler_dist_howler_js":"314aa633375f854ab529"}[chunkId] + ".js";
};